import React, { useState } from "react";
import GenerationPeriodLabel from "./GenerationPeriodLabel.tsx";
import {  Pencil ,Settings} from "lucide-react";
import Button from "@/components/button/Button";
import SolverSettingsModal from "@/components/modals/SolverSettingsModal.tsx";
import type { DateFilter, Schedule, SolverConfigs } from "@/types.ts";
import { updateSolverConfigs } from "@/api.ts";
import SolverPhasesModal from "@/components/modals/SolverPhasesModal.tsx";

interface HeaderProps {
    startDate: string | null;
    endDate: string | null;
    dateRange?: string;
    onDatesChange: (startDate: string, endDate: string) => void;
    depConfig  : SolverConfigs | undefined
    onUpdateSolverConfigs: () => void;
    onScheduleGenerationSettingsChanged?: () => void;
    schedule: Schedule | null;
    dateFilter?: DateFilter | null;
    onChangeDateFilter?: (value: DateFilter | null) => void;
}

const Header: React.FC<HeaderProps> = (
    {
        startDate,
        endDate,
        dateRange,
        onDatesChange,
        depConfig: depConfig,
        onUpdateSolverConfigs,
        onScheduleGenerationSettingsChanged,
        schedule,
        dateFilter,
        onChangeDateFilter
    }) => {

    const [confirmOpen, setConfirmOpen] = useState(false);

    return (
        <header className="w-full mb-8">
             <div className="flex flex-row items-center gap-2 mt-2">
                 <h2 className="text-3xl font-semibold">Génération IA 🧠</h2>
                 <div className="grow"></div>
                 <div>
                     <Button type="primary" icon={<Settings size={20}/>}  onClick={() => setConfirmOpen(true)}/>
                 </div>
                
             </div>
           
                
           
            <div className="mt-4">
                <GenerationPeriodLabel
                    startDate={startDate}
                    endDate={endDate}
                    dateRange={dateRange}
                    onDatesChange={onDatesChange}
                />
            </div>
            <SolverPhasesModal
                schedule={schedule}
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={async (editData)=>{
                
                   // await updateSolverConfigs(editData);
                    //onUpdateSolverConfigs();
                }}
                title="Configuration de département"
                confirmDisabled={false}
                depConfigs={depConfig}
                onUpdateSolverConfigs={onUpdateSolverConfigs}
                onScheduleGenerationSettingsChanged={onScheduleGenerationSettingsChanged}
                dateFilter={dateFilter}
                onChangeDateFilter={onChangeDateFilter}
                generationStart={startDate}
                generationEnd={endDate}
            ></SolverPhasesModal>
            {/* <SolverSettingsModal
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={async (editData)=>{
                    await updateSolverConfigs(editData);
                    onUpdateSolverConfigs();
                }}
                title="Configurations"
                confirmDisabled={false}
                solverConfigs={solverConfigs}
      
            /> */}
        </header>
    );
};

export default Header;
